export class BeusableTracker {
  static create(opts, context) {
    return new BeusableTracker(opts, context);
  }

  constructor({ id, ba }, context) {
    this.name = 'beusable';
    this.id = id;
    this.subcontext = '__beusablerumclient__';
    context[this.subcontext] = {
      load: function (src) {
        const el = document.createElement('script');
        el.src = src;
        el.async = true;
        el.type = 'text/javascript';
        document.getElementsByTagName('head')[0].appendChild(el);
      },
    };
    context[this.subcontext].load(`//rum.beusable.net/script/${this.id}`);
    // XXX: load 후 다른 이벤트가 있는 것으로 추정됨. 또 다른 스크립트를 로드함.
    // V2-2903
    if (ba) {
      context.__baclient__ = {
        load: function (src) {
          var el = document.createElement('script');
          el.src = src;
          el.async = true;
          el.type = 'text/javascript';
          document.getElementsByTagName('head')[0].appendChild(el);
        },
      };
      context.__baclient__.load(`//ba.beusable.net/script/${ba}`);
    }
  }

  track(event, data) {}
}
